import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { reduxForm } from 'redux-form'

import { tryToRecoverAccount } from '../../actions/actions.export.js';
import Button from '../Button/Button.js'
import CustomField from '../CustomField/CustomField.js'

import './ForgotForm.css';


class ForgotForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      email: props.user.recoverForm.lastSubmit.email
    }

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e){
    const { dispatch } = this.props; 
    dispatch(tryToRecoverAccount(this.state));
    if(e) e.preventDefault();
  }

  render(){
    const { user } = this.props; 
    const state = this.state;

    let formDisabled = !state.email;

    return (
      <div className="forgot-form">
      
        <form onSubmit={(e) => {
          e.preventDefault();
          if(!formDisabled) this.handleSubmit(e);
        }}>

          <CustomField 
            type="text"
            regex="email"
            name="email"
            placeholder="email address"
            label="Email"
            onChange={(e) => {this.setState({email: e}); }}
            serverErrors={user.recoverForm.errors.email}
            required={true}
            disabled={user.tryingToRecoverAccount}
          />
          
          <div className="text-center">
            <br/>
            
            <Button 
              submit={true} 
              disabled={formDisabled} 
              thinking={user.tryingToRecoverAccount} 
              successful={user.successfullyRecoveredAccount}
              failed={user.failedToRecoverAccount}
              onClick={this.handleSubmit} 
              display="Recover"
              size="large" 
              block={true}
              color="success"
            />
            <br/>
            <small>
            {
              user.recoverAccountSent ? 
              <span>
                  If there is an account associated with that email address, a recovery link has been sent to reset your password.
                </span> 
                : 
                <span>
                  We'll send a link to your email to reset your password.
                </span>
            }
            </small>
          </div>
        </form>
      </div>
    )
  }
}


ForgotForm = reduxForm({
  form: 'ForgotForm',
  enableReinitialize: true,
  destroyOnUnmount: false
})(ForgotForm)

ForgotForm = connect((state, ownProps) => {
  const { user } = state;

  var initialValues = {
    
  };
  
  return {
    user,
    initialValues
  }
})(ForgotForm);

export default ForgotForm;



// WEBPACK FOOTER //
// ./src/components/ForgotForm/ForgotForm.js